// @flow
import client, { saveJWTToken } from '../../client'

// API Endpoint
export const SSO_TOKEN_ENDPOINT = '/auth/sso-token'

/**
 * SSO Token Login user with encrypted user id
 * @param {string} token The sso token
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const ssoToken = (token: string): Promise<any> =>
  client
    .get(SSO_TOKEN_ENDPOINT, { query: { sso_token: token } })
    .then(({ jwt, refresh_token }) =>
      saveJWTToken({
        token: jwt,
        refresh_token,
      })
    )

export default ssoToken
